<template>
    <div class="view view--campaigns">
        <p class="has-margin-b30">
            <strong
                v-html="
                    __(
                        'This is where you can create unique links from celebrity campaigns.'
                    )
                "
            ></strong>
        </p>

        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            v-html="__('+ Add campaign')"
            v-on:click="isOpenAddModal = true"
        ></btn>

        <add-modal
            v-bind:errors="errors"
            v-bind:is-open-add-modal="isOpenAddModal"
            v-on:close="isOpenAddModal = false"
            v-on:create="createCampaign"
        />

        <edit-modal
            v-bind:campaign="editedCampaign"
            v-bind:errors="errors"
            v-bind:is-open-edit-modal="isOpenEditModal"
            v-on:close="isOpenEditModal = false"
            v-on:update="updateCampaign"
        />
        <delete-modal
            v-bind:id="deleteId"
            v-bind:is-open-delete-modal="isOpenDeleteModal"
            v-on:close="isOpenDeleteModal = false"
            v-on:delete="deleteCampaign"
        />
    </div>
</template>

<script>
import AddModal from './components/AddModal';
import CelebrityCampaignRepository from '../../repositories/CelebrityCampaignRepository';
import DeleteModal from './components/DeleteModal';
import EditModal from './components/EditModal';
import MessageHandler from '../../messageHandler';
import store from '../../store';
import { Btn, DataTable } from '@teamfurther/cinderblock';

export default {
    components: {
        AddModal,
        Btn,
        DataTable,
        DeleteModal,
        EditModal
    },
    data: function() {
        return {
            campaigns: [],
            celebrityCampaignRepository: new CelebrityCampaignRepository(),
            deleteId: null,
            editedCampaign: {},
            errors: {},
            isOpenAddModal: false,
            isOpenDeleteModal: false,
            isOpenEditModal: false,
            tableData: {
                columnNames: {
                    name: this.__('Name'),
                    program: this.__('Program name'),
                    url: this.__('URL'),
                    qr: this.__('QR')
                },
                items: [],
                sortableColumns: ['name', 'program']
            }
        };
    },
    methods: {
        createCampaign: async function(campaign) {
            try {
                await this.celebrityCampaignRepository.storeCelebrityCampaign(
                    campaign.programId,
                    campaign.userId
                );

                this.isOpenAddModal = false;

                await this.getCampaigns();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Celebrity campaign was successfully created.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        deleteCampaign: async function(id) {
            try {
                await this.celebrityCampaignRepository.deleteCelebrityCampaigns(
                    id
                );

                this.isOpenDeleteModal = false;

                await this.getCampaigns();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Celebrity campaign was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
                this.errors = error.data;
            }
        },
        getCampaigns: async function(sort = '') {
            try {
                this.campaigns = await this.celebrityCampaignRepository.getCelebrityCampaigns(
                    sort
                );

                let items = [];

                this.campaigns.forEach(item =>
                    items.push(this.transformDataForDataTable(item))
                );

                this.$set(this.tableData, 'items', items);
            } catch (e) {}
        },
        sortDataTable: function(sortByColumn) {
            this.getCampaigns(sortByColumn);
        },
        transformDataForDataTable: function(item) {
            let actions = [];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                method: 'showEditModal',
                title: this.__('Edit')
            });

            return {
                values: {
                    id: item.id,
                    name: item.user.name,
                    program: item.program?.title,
                    qr:
                        '<img style="height: 100px" src="data:image/svg+xml;base64,' +
                        item.qr_code +
                        '" />',
                    url: '<a href="' + item.link + '">Link</a>'
                },
                actions: actions
            };
        },
        showDeleteModal: function(data) {
            this.deleteId = data.id;
            this.isOpenDeleteModal = true;
        },
        showEditModal: function(data) {
            this.editedCampaign = this.campaigns.find(
                item => item.id === data.id
            );
            this.isOpenEditModal = true;
        },
        updateCampaign: async function(campaign) {
            try {
                await this.celebrityCampaignRepository.updateCelebrityCampaign(
                    campaign.id,
                    campaign.programId,
                    campaign.userId
                );

                this.isOpenEditModal = false;

                await this.getCampaigns();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Celebrity campaign was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
                this.errors = error.data;
            }
        }
    },
    mounted: function() {
        this.getCampaigns();
    }
};
</script>
